// extracted by mini-css-extract-plugin
export var container = "CgCheckbox-module--container--1cc7a";
export var disabled = "CgCheckbox-module--disabled--7a149";
export var highContrast = "CgCheckbox-module--high-contrast--4ea28";
export var label = "CgCheckbox-module--label--ee446";
export var square = "CgCheckbox-module--square--0391b";
export var tick = "CgCheckbox-module--tick--a4398";